import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceDocumentDeleteAction from './machineServiceDocumentDelete.action.json' with { type: 'json' }
import { machineServiceDocumentObject } from '../machineServiceDocumentObject'

const machineServiceDocumentDeleteDefinition = defineAction({
  ...machineServiceDocumentDeleteAction,

  input: z.object({ id: machineServiceDocumentObject.shape.id }),
  output: z.object({}),
})

export default machineServiceDocumentDeleteDefinition
